import React, { useState } from 'react'
import { useTranslation } from 'i18n'
import IconListItem from './IconListItem'
import ReceiptDropzoneButton from './ReceiptDropzoneButton'
import ReceiptViewHeader from 'steps/receipt/components/ReceiptViewHeader'
import { useAuthRequired } from 'hooks/useAuthRequired'
import './HowItWorksView.scss'
import UploadByCamera from 'components/UploadByCamera'

const HowItWorksView = ({
  themeColors,
  handleImageUpload,
  headline,
  introCopy,
  headerImage,
  instructions,
  userPathHeadline,
  onNotYetClicked = function () {},
  handleUploadError,
  sizeError,
  typeError,
  amountError,
  enableReminder,
  isEmbed = false,
}) => {
  const { t } = useTranslation('receipt')
  const { authRequiredAction, isLoggedIn } = useAuthRequired(isEmbed)
  const { primaryCopyColor, primaryColorButtons } = themeColors
  //respect order properties in beaker.config.js
  const sortedInstructions = instructions.sort(
    (a, b) => a.displayOrder - b.displayOrder,
  )
  return (
    <div className="receipt-view how-it-works-view">
      <ReceiptViewHeader
        headline={headline}
        introCopy={introCopy}
        headerImage={headerImage}
      />
      <div className={`receipt-view-content`}>
        {instructions && (
          <ul className={`how-it-works-list`}>
            {sortedInstructions.map((instruction, index) => {
              return (
                <IconListItem
                  key={index}
                  {...instruction}
                  iconBackgroundClr={primaryColorButtons}
                  iconBorderClr={primaryCopyColor}
                />
              )
            })}
          </ul>
        )}
      </div>
      {userPathHeadline && (
        <h3
          className="receipt-path-headline"
          dangerouslySetInnerHTML={{ __html: userPathHeadline }}
        />
      )}
      <div className={`receipt-button-container`} style={{ gap: '10px' }}>
        {enableReminder && (
          <button
            className="btn themed-button-secondary"
            onClick={onNotYetClicked}
          >
            {t('notYet')}
          </button>
        )}
        {isLoggedIn ? (
          <>
            <ReceiptDropzoneButton
              onUpload={handleImageUpload}
              onError={handleUploadError}
              className="btn themed-button"
            />
            <UploadByCamera
              onUpload={handleImageUpload}
              onError={handleUploadError}
              className="receipt-upload-button"
              buttonClassName="btn themed-button"
            />
          </>
        ) : (
          <button className="btn themed-button" onClick={authRequiredAction}>
            {t('uploadCta')}
          </button>
        )}
      </div>
      <div>
        {sizeError && <p className="error">{t('error.imageTooLarge')}</p>}
        {typeError && (
          <p className="error">{t('error.unsupportedImageType')}</p>
        )}
        {amountError && <p className="error">{t('error.tooManyImages')}</p>}
      </div>
    </div>
  )
}
export default HowItWorksView
